import { fmtINR } from "@/lib/api";
import { Building2 } from "lucide-react";

function L({ label, value, bold }) {
  return (
    <div className={`flex justify-between py-1.5 text-sm ${bold ? "font-semibold border-t border-slate-200 pt-2 mt-1" : ""}`}>
      <span className={bold ? "" : "text-slate-600"}>{label}</span>
      <span className="font-mono">{value}</span>
    </div>
  );
}

export default function Payslip({ slip }) {
  const monthLabel = new Date(slip.month + "-01").toLocaleDateString("en-IN", { month: "long", year: "numeric" });
  const e = slip.earnings, d = slip.deductions;
  return (
    <div className="print-area bg-white text-slate-900 rounded-xl border border-slate-200 overflow-hidden" data-testid="payslip-container">
      <div className="p-8">
        <div className="flex items-center justify-between border-b-2 border-slate-900 pb-4">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-lg bg-white border border-slate-200 overflow-hidden flex items-center justify-center"><img src="/logo.jpg" alt="Skanovix logo" className="w-full h-full object-cover" /></div>
            <div>
              <p className="font-heading font-extrabold tracking-tight">Skanovix Info Tech Solutions</p>
              <p className="text-xs text-slate-500 font-mono uppercase tracking-widest">Payslip — {monthLabel}</p>
            </div>
          </div>
          <div className="text-right text-xs text-slate-500"><p>Confidential</p><p>Bengaluru, KA</p></div>
        </div>

        <div className="grid grid-cols-2 gap-x-8 gap-y-1 mt-5 text-sm">
          <L label="Employee" value={slip.employee_name} />
          <L label="Employee ID" value={slip.employee_id} />
          <L label="Designation" value={slip.designation} />
          <L label="Pay Period" value={monthLabel} />
        </div>

        <div className="grid sm:grid-cols-2 gap-6 mt-6">
          <div>
            <p className="font-heading font-bold text-sm uppercase tracking-wide bg-emerald-50 text-emerald-800 px-3 py-1.5 rounded">Earnings</p>
            <div className="px-1 mt-1">
              <L label="Basic Salary" value={fmtINR(e.basic)} />
              <L label="House Rent Allowance" value={fmtINR(e.hra)} />
              <L label="Special Allowance" value={fmtINR(e.special_allowance)} />
              <L label="Gross Earnings" value={fmtINR(slip.gross)} bold />
            </div>
          </div>
          <div>
            <p className="font-heading font-bold text-sm uppercase tracking-wide bg-rose-50 text-rose-800 px-3 py-1.5 rounded">Deductions</p>
            <div className="px-1 mt-1">
              <L label="Provident Fund (EPF)" value={fmtINR(d.pf_employee)} />
              {d.esi_employee > 0 && <L label="ESI (0.75%)" value={fmtINR(d.esi_employee)} />}
              <L label="Income Tax (TDS)" value={fmtINR(d.tds)} />
              {slip.tax_regime && <L label="Tax Regime" value={slip.tax_regime === "old" ? `Old${slip.declared_80c ? ` (80C ${fmtINR(slip.declared_80c)})` : ""}` : "New"} />}
              <L label="Total Deductions" value={fmtINR(slip.total_deductions)} bold />
            </div>
          </div>
        </div>

        <div className="mt-6 bg-slate-900 text-white rounded-lg px-5 py-4 flex items-center justify-between">
          <span className="font-heading font-bold">Net Pay for {monthLabel}</span>
          <span className="font-mono font-extrabold text-xl">{fmtINR(slip.net)}</span>
        </div>
        <p className="text-[10px] text-slate-400 mt-5 text-center font-mono">System-generated payslip. Annual CTC: {fmtINR(slip.annual_ctc)}. Computed per Indian statutory norms.</p>
      </div>
    </div>
  );
}
